import {
  hexToRgba,
  listedSchedulerType,
  schedulerTypeMeta,
} from "../../utils/schedulerTypes";

export const resolveSchedulerClasses = (element) => {
  const options = element.options;
  let classes = "element-content cf-scheduler-outer ";
  let alignmentClass = "cf-outer-center";

  if (options["cf-alignment"]) {
    if (options["cf-alignment"].indexOf("left") > -1) {
      alignmentClass = "cf-outer-left";
    } else if (options["cf-alignment"].indexOf("center") > -1) {
      alignmentClass = "cf-outer-center";
    } else if (options["cf-alignment"].indexOf("right") > -1) {
      alignmentClass = "cf-outer-right";
    }
  }

  classes += " " + alignmentClass;

  return classes;
};

export const buildSchedulerStylesheet = (
  builder,
  device,
  cta,
  element,
  variant
) => {
  const options = { ...(element.options || {}) };
  const theme = (variant && variant.options) || {};

  const present = (value) =>
    value !== undefined && value !== null && value !== "";

  const pick = (key, fallback) => {
    if (present(options[key])) return options[key];
    if (present(theme[key])) return theme[key];
    return fallback;
  };

  let boxShadow;
  if (options["box-shadow"] == "soft") {
    boxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
  }
  if (options["box-shadow"] == "hard") {
    boxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
  }
  if (options["box-shadow"] == "custom") {
    boxShadow = "";
    boxShadow +=
      (options["box-shadow-horizontal-distance"]
        ? `${options["box-shadow-horizontal-distance"]}px`
        : "0px") + " ";
    boxShadow +=
      (options["box-shadow-vertical-distance"]
        ? `${options["box-shadow-vertical-distance"]}px`
        : "0px") + " ";
    boxShadow +=
      (options["box-shadow-blur-radius"]
        ? `${options["box-shadow-blur-radius"]}px`
        : "0px") + " ";
    boxShadow +=
      (options["box-shadow-spread-radius"]
        ? `${options["box-shadow-spread-radius"]}px`
        : "0px") + " ";
    boxShadow += options["box-shadow-color"]
      ? options["box-shadow-color"]
      : "rgba(0,0,0, 0.35)";
  }

  const maxWidth = pick("scheduler-max-width");
  const minHeight = pick("scheduler-min-height", "700");
  const borderStyle = pick("scheduler-border-style", "none");
  const borderColor = pick("scheduler-border-color", "#000");
  const borderRadius = pick("scheduler-border-radius");
  const borderWidthLeft = pick("scheduler-border-width-left", "1");
  const borderWidthRight = pick("scheduler-border-width-right", "1");
  const borderWidthTop = pick("scheduler-border-width-top", "1");
  const borderWidthBottom = pick("scheduler-border-width-bottom", "1");
  const hasBorder = borderStyle && borderStyle !== "none";

  const maxWidthMobile = pick("scheduler-max-width-mobile");
  const minHeightMobile = pick("scheduler-min-height-mobile");
  const schedulerType = listedSchedulerType(
    options["scheduler_type"] || "calendly"
  );
  const brand = schedulerTypeMeta(schedulerType);
  const brandColor = brand.color;
  const brandFill = hexToRgba(brandColor, 0.1);

  // prettier-ignore
  const desktopStyles =
`#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-scheduler-outer {
  ${boxShadow ? "box-shadow: " + boxShadow + " !important;" : ""}
  ${maxWidth ? "max-width: " + maxWidth + "px !important;" : ""}
  width: 100%;
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-scheduler {
  width: 100%;
  min-height: ${minHeight}px;
  box-sizing: border-box;
  ${hasBorder ? `border-style: ${borderStyle} !important;` : ""}
  ${hasBorder ? `border-color: ${borderColor} !important;` : ""}
  ${hasBorder ? `border-left-width: ${borderWidthLeft}px !important;` : ""}
  ${hasBorder ? `border-right-width: ${borderWidthRight}px !important;` : ""}
  ${hasBorder ? `border-top-width: ${borderWidthTop}px !important;` : ""}
  ${hasBorder ? `border-bottom-width: ${borderWidthBottom}px !important;` : ""}
  ${borderRadius ? `border-radius: ${borderRadius}px !important;` : ""}
  ${borderRadius ? `clip-path: inset(0 round ${borderRadius}px);` : ""}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-scheduler iframe {
  width: 100%;
  min-height: ${minHeight}px;
  border: 0;
  display: block;
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-html-placeholder {
  width: 100%;
  min-height: ${minHeight}px;
  background: ${brandFill} !important;
  border: 0 !important;
  opacity: 1 !important;
  overflow: hidden !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-scheduler-placeholder-icon {
  width: 48px;
  height: 48px;
  object-fit: contain;
  margin-bottom: 12px;
}
`;

  // prettier-ignore
  const mobileStyles =
`/* mobile styles */
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-scheduler-outer {
  ${maxWidthMobile ? "max-width: " + maxWidthMobile + "px !important;" : ""}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-scheduler,
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-scheduler iframe,
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-html-placeholder {
  ${minHeightMobile ? `min-height: ${minHeightMobile}px !important;` : ""}
}
`;

  if (builder !== true) {
    return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
  } else {
    if (device == "desktop") {
      return desktopStyles;
    } else {
      return desktopStyles + mobileStyles;
    }
  }
};
